import { configureStore } from "@reduxjs/toolkit";
import blogsReducer from "../features/blogs/BlogsSlice";
import blogReducer from "../features/blog/BlogSlice";
import relatedBlogsReducer from '../features/relatedBlogs/RelatedBlogsSlice';
import filterReducer from "../features/filter/filterSlice";
import sortReducer from "../features/sort/SortSlice";

export const store = configureStore({
	reducer: {
		blogs: blogsReducer,
		blog: blogReducer,
		relatedBlogs: relatedBlogsReducer,
		filter: filterReducer,
		sort: sortReducer,
	},
});
